import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

const ACCOUNT_LOAD_QUERY_KEY = '/account/<accountId>';

export function useAccountLoad({ accountId, meta }: { accountId: string; meta?: LevStandardQueryMeta }) {
	const userSession = useUserSession();
	return useQuery({
		queryFn: () =>
			new Promise<Api.IAccount>((resolve, reject) =>
				userSession.webServiceHelper.callWebServiceWithOperationResults<Api.IAccount>(
					`account/${accountId}`,
					'GET',
					null,
					opResult => {
						resolve(opResult.value);
					},
					opResult => {
						reject(opResult);
					}
				)
			),
		queryKey: [ACCOUNT_LOAD_QUERY_KEY, accountId],
		meta,
	});
}

export const invalidateAccountLoad = () => {
	reactQueryClient.invalidateQueries({ queryKey: [ACCOUNT_LOAD_QUERY_KEY] });
};
